module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_06_1280_1280_ja-b664b7e48cd337991a1bbaeb141a6bcc.jpg";